export const CATALOG_ITEM_NAME_MAX_LENGTH = 300;
export const CATALOG_ITEM_DESCRIPTION_MAX_LENGTH = 3000;
export const CATALOG_ITEM_SKU_MAX_LENGTH = 30;
export const IMAGE_URL_PREFIX = 'https://flipdish.imgix.net/';
export const INTERNAL_NOTES_METAFIELD_KEY = 'internal.notes';
export enum VIEW_MODE {
  LIST,
  GRID,
}
